var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"center"},[_c('el-button',{staticClass:"white-text link",attrs:{"type":"text"}},[_c('router-link',{attrs:{"to":'login'}},[_vm._v(" Back to login page")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }